// layouts/MainLayout.jsx
import React from "react";
import mainStyle from "../style/Main.module.css";
import SideBar from "../components/bars/SideBar";

const SecondaryLayout = ({ children }) => {
  return (
    <div className={mainStyle.maincontainer}>
      <div className={mainStyle.mainContainerSub}>
        <SideBar />
        {/* <SettingsBar /> */}
        <div className={mainStyle.secondaryContent}>
          {/* <Header /> */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default SecondaryLayout;
